import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('=== ERROR BOUNDARY CAUGHT ===');
    console.error('Error:', error.message);
    console.error('Full error:', error);
    console.error('Stack:', error.stack);
    console.error('Component Stack:', info.componentStack);
    this.setState({ errorInfo: info });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', fontFamily: 'monospace', background: '#1a1a2e', color: '#e0e0e0', minHeight: '100vh' }}>
          <h1 style={{ color: '#ff6b6b' }}>Application Error</h1>
          <h2 style={{ color: '#ffd93d' }}>{this.state.error?.message}</h2>
          <pre style={{ background: '#0d1117', padding: '1rem', borderRadius: '8px', overflow: 'auto', fontSize: '12px', color: '#ff6b6b' }}>
            {this.state.error?.stack}
          </pre>
          {this.state.errorInfo && (
            <>
              <h3 style={{ color: '#ffd93d', marginTop: '1rem' }}>Component Stack:</h3>
              <pre style={{ background: '#0d1117', padding: '1rem', borderRadius: '8px', overflow: 'auto', fontSize: '12px', color: '#4ecdc4' }}>
                {this.state.errorInfo.componentStack}
              </pre>
            </>
          )}
          <button
            onClick={() => window.location.reload()}
            style={{ marginTop: '1rem', padding: '0.5rem 1rem', background: '#6366f1', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
          >
            Reload Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
